import { render, staticRenderFns } from "./ApiNotification.vue?vue&type=template&id=43c74beb&scoped=true"
import script from "./ApiNotification.vue?vue&type=script&lang=js"
export * from "./ApiNotification.vue?vue&type=script&lang=js"
import style0 from "./ApiNotification.vue?vue&type=style&index=0&id=43c74beb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c74beb",
  null
  
)

export default component.exports